import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminSeo() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/seo");
      setItems(data);
    } catch { toast.error("Load failed"); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const update = (id, k, v) => setItems((prev) => prev.map((it) => (it.id === id ? { ...it, [k]: v } : it)));

  const save = async (it) => {
    try {
      await api.put(`/admin/seo/${it.id}`, {
        page_name: it.page_name, page_slug: it.page_slug, seo_title: it.seo_title,
        meta_description: it.meta_description, target_keywords: it.target_keywords,
        canonical_url: it.canonical_url || "", index_page: !!it.index_page,
      });
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
  };

  return (
    <div data-testid="admin-seo-page">
      <h2 className="text-2xl font-display font-bold text-[#0F172A]">SEO Settings</h2>
      <p className="text-sm text-[#475569] mt-1">Page titles, meta descriptions, and keywords used on the public site.</p>

      <div className="mt-6 space-y-3">
        {loading ? <div className="text-sm text-[#475569]">Loading…</div> : items.map((it) => (
          <div key={it.id} className="bg-white rounded-2xl border border-slate-100 p-5" data-testid={`seo-item-${it.page_slug}`}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-display font-semibold text-[#0F172A]">{it.page_name}</h3>
              <code className="text-xs text-slate-500">/{it.page_slug}</code>
            </div>
            <div className="space-y-3">
              <label className="block">
                <span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">SEO title</span>
                <input data-testid={`seo-${it.page_slug}-title`} value={it.seo_title || ""} onChange={(e) => update(it.id, "seo_title", e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm" />
              </label>
              <label className="block">
                <span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Meta description</span>
                <textarea data-testid={`seo-${it.page_slug}-desc`} value={it.meta_description || ""} rows={2} onChange={(e) => update(it.id, "meta_description", e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm" />
              </label>
              <div className="grid sm:grid-cols-2 gap-3">
                <label className="block">
                  <span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Target keywords</span>
                  <input data-testid={`seo-${it.page_slug}-keywords`} value={it.target_keywords || ""} onChange={(e) => update(it.id, "target_keywords", e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm" />
                </label>
                <label className="block">
                  <span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Canonical URL (optional)</span>
                  <input value={it.canonical_url || ""} onChange={(e) => update(it.id, "canonical_url", e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm" />
                </label>
              </div>
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={!!it.index_page} onChange={(e) => update(it.id, "index_page", e.target.checked)} className="w-4 h-4" />
                <span className="text-sm">Index this page (uncheck for noindex)</span>
              </label>
            </div>
            <div className="mt-4 flex justify-end">
              <button onClick={() => save(it)} data-testid={`seo-${it.page_slug}-save`} className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-[#1E3A8A] text-white text-sm font-semibold hover:bg-[#1E40AF]">
                <Save className="w-3.5 h-3.5" /> Save
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
